import { Button, createStyles } from '@mantine/core'

import { Tile } from '../../components/tile'
import { AngularStyle } from '../../components/angular-style'
import { Splash, SplashTitle } from '../../components/splash'
import img1 from '../../assets/large_mof_background.svg'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'

const useStyles = createStyles((theme) => ({
  splashText: {
    h1: {
      [theme.fn.smallerThan('sm')]: {
        fontSize: `${theme.fontSizes.lg * 2}px !important`,
      },
    },
    justifyContent: 'start',
    height: '100%',
  },

  text: {
    padding: '2em 8em',
    [theme.fn.smallerThan('lg')]: {
      padding: '1em 1.5em',

      [theme.fn.smallerThan('sm')]: {
        padding: theme.spacing.sm,
      },
    },
  },
}))

export function PersonalTraining() {
  const { classes } = useStyles()

  return (
    <main>
      <Helmet>
        <title>Personal Training in Coventry | Mistry Of Fitness</title>
        <meta
          name='description'
          content='Personal training in Coventry ✓ | 1-1 tailored fitness coaching for strength, fat loss & beginners | Train privately at Simply Gym | Book a free consultation →'
        />
      </Helmet>

      <Splash height={'calc(100vh - 56px)'} backgroundSrc={`url(${img1})`}>
        <div className={classes.splashText}>
          <SplashTitle>Personal Training in Coventry</SplashTitle>
        </div>
      </Splash>

      <div className='about-tile'>
        <Tile tileOpts={{ colour: 'bg-black', accent: 'bg-black', style: 'simple-3' }} mh={200}>
          <div className={classes.text}>
            <p>
              Are you ready to unlock your full fitness potential with expert personal training in
              Coventry? I specialise in delivering personalised 1-1 coaching designed to help you
              build strength, lose fat, and improve overall wellbeing—all in the comfort and privacy
              of Simply Gym Coventry.
            </p>
          </div>
        </Tile>
        <Tile
          tileOpts={{ colour: 'bg-primary', accent: 'brand-primary', style: 'simple-1' }}
          mh={200}
        >
          <div className={classes.text}>
            <h2>Why Choose Me as Your Personal Trainer in Coventry?</h2>
            <p>
              With years of experience in fitness coaching, I understand that every client’s journey
              is unique. My approach combines scientific training principles with practical
              lifestyle adjustments, tailored precisely to your goals and abilities. Whether you’re
              a beginner just starting out or someone looking to break through a plateau, I’m here
              to guide and motivate you.
            </p>
          </div>
        </Tile>
        <Tile
          tileOpts={{ colour: 'brand-secondary', accent: 'bg-tertiary', style: 'simple-3' }}
          mh={200}
        >
          <div className={classes.text}>
            <h2>Proven Expertise & Personalised Coaching</h2>
            <p>
              As a certified personal trainer with extensive backgrounds in strength training, fat
              loss, and injury prevention, I conduct thorough initial assessments to evaluate your
              current fitness level, identify imbalances, and understand your goals. Using this
              information, I craft customised training plans that evolve with you.
            </p>
          </div>
        </Tile>
        <Tile
          tileOpts={{ colour: 'bg-tertiary', accent: 'brand-primary', style: 'simple-1' }}
          mh={200}
        >
          <div className={classes.text}>
            <h2>What to Expect from Your Personal Training Sessions</h2>
            <ul>
              <li>
                <strong>Initial Consultation & Fitness Assessment:</strong> Establish your baseline
                fitness and discuss your goals.
              </li>
              <li>
                <strong>Tailored Training Program:</strong> Your workouts focus on progressive
                strength gains, mobility, and cardiovascular fitness.
              </li>
              <li>
                <strong>Nutritional Guidance:</strong> I provide practical advice to complement your
                training and accelerate results.
              </li>
              <li>
                <strong>Ongoing Monitoring:</strong> Regular progress reviews ensure your program
                adapts as you improve.
              </li>
              <li>
                <strong>Flexible Scheduling:</strong> I fit sessions around your lifestyle, making
                consistency achievable.
              </li>
            </ul>
          </div>
        </Tile>
        <Tile
          tileOpts={{ colour: 'brand-tertiary', accent: 'bg-primary', style: 'simple-2' }}
          mh={200}
        >
          <div className={classes.text}>
            <h2>Why Local Matters: Personal Training Near You in Coventry</h2>
            <p>
              Training with a local expert means convenience, accountability, and community support.
              I offer sessions at Simply Gym Coventry—a well-equipped, welcoming environment
              designed for private coaching. By focusing on personal training near me in Coventry, I
              build strong local relationships and deliver a highly personalised experience.
            </p>

            <br />

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Link to='/services' style={{ margin: '1.2em' }}>
                <Button
                  variant='light'
                  radius='xl'
                  size='lg'
                  styles={{
                    root: { padding: '0 14', height: 48 },
                  }}
                >
                  View More Personal Training Options
                </Button>
              </Link>
            </div>
          </div>
        </Tile>
        <Tile tileOpts={{ colour: 'bg-primary', accent: 'bg-primary', style: 'simple-3' }} mh={200}>
          <div className={classes.text}>
            <h2>Trusted by Coventry Clients</h2>
            <p>
              My clients consistently praise my supportive coaching style and ability to deliver
              real results. With glowing reviews and a reputation for professionalism, I am a
              trusted personal trainer in Coventry.
            </p>

            <br />

            <Link to='/testimonials' style={{ margin: '1.2em' }}>
              <Button
                variant='filled'
                radius='xl'
                size='md'
                styles={{
                  root: { padding: '0 14', height: 48 },
                }}
              >
                Read Reviews
              </Button>
            </Link>
          </div>
        </Tile>
        <Tile
          tileOpts={{ colour: 'brand-primary', accent: 'bg-black', style: 'simple-1' }}
          mh={200}
        >
          <div className={classes.text}>
            <h2>Start Your Fitness Journey Today</h2>
            <p>
              If you’re ready to take control of your health and fitness with expert guidance,
              contact me. Book your free consultation and discover how personalised coaching can
              transform your body and confidence.
            </p>
            <a
              href='/contact-faqs'
              style={{ color: '#007bff', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Contact Rik to secure your spot with one of Coventry’s leading personal trainers!
            </a>
          </div>

          <div className={classes.text}>
            <iframe
              title='Personal Training Coventry Location'
              src='https://www.google.com/maps?q=Simply+Gym,+Earl+Place+Business+Park,+Fletchamstead+Highway,+Coventry+CV4+9XL&output=embed'
              width='100%'
              height='350'
              style={{ border: 0 }}
              allowFullScreen={true}
              loading='lazy'
              referrerPolicy='no-referrer-when-downgrade'
            ></iframe>
          </div>
        </Tile>
      </div>

      <AngularStyle
        className='test'
        colour='brand-secondary'
        style={3}
        side={'right'}
        size={'sm'}
        height={'50px'}
        width={'100%'}
      ></AngularStyle>
    </main>
  )
}
